import React from 'react'
import styled from 'styled-components'
import Medallia from './Medallia'

const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
`
const ReportContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
`
const TitleContainer = styled.div`
  width: 100%;
  padding: 0 30px 30px 30px;
  box-sizing: border-box;
  display: flex;
`

const MedalliaReport = ({ fromCenter, match }) => (
  <Container>
    {!fromCenter && (
      <TitleContainer>
        <h1>Medallia</h1>
      </TitleContainer>
    )}
    <ReportContainer>
      <Medallia match={match} fromCenter={fromCenter} />
    </ReportContainer>
  </Container>
)

export default MedalliaReport



// WEBPACK FOOTER //
// ./src/Containers/Reports/MedalliaReport.jsx